import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import { CheckCircle2, MessageCircle, Trophy, ChevronRight, ShieldCheck, Zap, Wallet, Headphones } from "lucide-react";
import { SITE, EXCHANGES, IMAGES } from "../data/mock";

export default function CricketID() {
  return (
    <div>
      <PageHero title="Online Cricket ID by OnlineCricketID" breadcrumb="Cricket ID" subtitle="India ka sabse trusted Online Cricket ID provider. Verified, fast aur 100% safe ID sirf 2 minute me - WhatsApp par message bhej kar." />

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-white">Exactly Cricket ID Kya Hai?</h2>
            <p className="mt-4 text-slate-300 leading-relaxed">
              Online Cricket ID ek verified account hai jo aapko trusted sports exchange platforms par access deta hai. Is ID se aap live matches dekh sakte ho, real-time odds analyze kar sakte ho aur back/lay betting kar sakte ho.
            </p>
            <p className="mt-3 text-slate-300 leading-relaxed">
              OnlineCricketID.guru par hum aapko top exchanges (TAJ777, ALLPANELEXCH, LORDSEXCH, TIGER365) ki verified ID provide karte hain - SSL secured, instant withdrawal aur 24/7 support ke saath.
            </p>
            <ul className="mt-6 space-y-2.5">
              {["Verified & SSL secured ID", "2 minute me instant activation", "650+ games access (cricket + casino)", "5% welcome bonus + 10% loss commission", "3-5 min me withdrawal", "24x7 WhatsApp + Telegram support"].map((t) => (
                <li key={t} className="flex items-center gap-2.5 text-slate-300"><CheckCircle2 className="w-5 h-5 text-amber-400" /> {t}</li>
              ))}
            </ul>
            <a href={SITE.whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold inline-flex items-center gap-2 px-6 py-3.5 rounded-xl mt-7">
              <MessageCircle className="w-5 h-5" /> Get Your Cricket ID
            </a>
          </div>
          <div className="rounded-3xl overflow-hidden border border-amber-500/20">
            <img src={IMAGES.battingAction} alt="Cricket" className="w-full h-[420px] object-cover" />
          </div>
        </div>
      </section>

      <section className="section-pad bg-gradient-to-b from-transparent via-[#0c1530]/40 to-transparent">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white">OnlineCricketID Cricket ID Features</h2>
            <p className="mt-3 text-slate-400">Wo features jo hamare Cricket ID ko market me sabse competitive banate hain.</p>
          </div>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { icon: Zap, t: "Instant Activation", d: "2 minute me ID active. No documents, no delays." },
              { icon: ShieldCheck, t: "Verified & Secure", d: "SSL encrypted platforms, KYC verified accounts." },
              { icon: Wallet, t: "Fast Payouts", d: "3-5 minute me UPI/Bank par instant withdrawal." },
              { icon: Headphones, t: "24x7 Support", d: "WhatsApp/Telegram par 60 second me reply guaranteed." },
            ].map((x) => (
              <div key={x.t} className="card-dark p-6">
                <div className="w-12 h-12 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center"><x.icon className="w-6 h-6 text-amber-400" /></div>
                <h3 className="mt-4 text-lg font-bold text-white">{x.t}</h3>
                <p className="mt-2 text-sm text-slate-400">{x.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white">Available Exchange IDs</h2>
            <p className="mt-3 text-slate-400">India ke top sports exchanges par direct verified ID. Demo credentials se test karo, fir live play karo.</p>
          </div>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {EXCHANGES.map((e) => (
              <div key={e.name} className="card-dark p-5">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-500/30 to-amber-400/10 border border-amber-500/30 flex items-center justify-center"><Trophy className="w-5 h-5 text-amber-400" /></div>
                <h3 className="mt-4 text-base font-extrabold text-white tracking-tight">{e.name}</h3>
                <div className="mt-3 space-y-1.5 text-xs text-slate-400">
                  <div className="flex items-center gap-1.5"><CheckCircle2 className="w-3.5 h-3.5 text-green-400" /> {e.bonus}</div>
                  <div className="flex items-center gap-1.5"><CheckCircle2 className="w-3.5 h-3.5 text-green-400" /> {e.commission}</div>
                </div>
                <a href={SITE.whatsappUrl} target="_blank" rel="noreferrer" className="btn-outline-gold mt-4 inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-lg w-full text-sm">
                  Get ID <ChevronRight className="w-4 h-4" />
                </a>
              </div>
            ))}
          </div>
          <div className="mt-10 text-center">
            <Link to="/how-to-play" className="btn-outline-gold inline-flex items-center gap-2 px-5 py-3 rounded-xl text-sm">Learn How to Play</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
